import { render, staticRenderFns } from "./PuzzleTemplateEdit.vue?vue&type=template&id=2ae71682&"
import script from "./PuzzleTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./PuzzleTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports